import { render } from "./ExcelMigration.vue?vue&type=template&id=68c3540e"
import script from "./ExcelMigration.vue?vue&type=script&lang=js"
export * from "./ExcelMigration.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/eccaplus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__